import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
    sidebarOpen: boolean;
    currentPage: string;
    snackbar: {
        open: boolean;
        message: string;
        severity: 'success' | 'error' | 'warning' | 'info';
    };
    loading: boolean;
    resultDialog: {
        open: boolean;
        title: string;
        message: string;
        severity: 'success' | 'error' | 'warning' | 'info';
        details?: string;
        nextPath?: string;
    };
}

const initialState: UIState = {
    sidebarOpen: true,
    currentPage: 'dashboard',
    snackbar: {
        open: false,
        message: '',
        severity: 'info',
    },
    loading: false,
    resultDialog: {
        open: false,
        title: '',
        message: '',
        severity: 'info',
        details: '',
        nextPath: '',
    },
};

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        toggleSidebar: (state) => {
            state.sidebarOpen = !state.sidebarOpen;
        },
        setSidebarOpen: (state, action: PayloadAction<boolean>) => {
            state.sidebarOpen = action.payload;
        },
        setCurrentPage: (state, action: PayloadAction<string>) => {
            state.currentPage = action.payload;
        },
        showSnackbar: (
            state,
            action: PayloadAction<{
                message: string;
                severity?: 'success' | 'error' | 'warning' | 'info';
            }>
        ) => {
            state.snackbar = {
                open: true,
                message: action.payload.message,
                severity: action.payload.severity || 'info',
            };
        },
        hideSnackbar: (state) => {
            state.snackbar.open = false;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        showResultDialog: (
            state,
            action: PayloadAction<{
                title: string;
                message: string;
                severity?: 'success' | 'error' | 'warning' | 'info';
                details?: string;
                nextPath?: string;
            }>
        ) => {
            state.resultDialog = {
                open: true,
                title: action.payload.title,
                message: action.payload.message,
                severity: action.payload.severity || 'info',
                details: action.payload.details || '',
                nextPath: action.payload.nextPath || '',
            };
        },
        hideResultDialog: (state) => {
            state.resultDialog.open = false;
            state.resultDialog.nextPath = '';
        },
    },
});

export const { toggleSidebar, setSidebarOpen, setCurrentPage, showSnackbar, hideSnackbar, setLoading, showResultDialog, hideResultDialog } =
    uiSlice.actions;
export default uiSlice.reducer;
